export default __webpack_public_path__ + "locales/ro/DeleteDialog.json?hash=2fb25d6aceaffa72b6e1976af3cce002";